import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultButton from 'components/Utils/NewDefaultButton';
import EditOHIP from 'components/Patient/OHIPFields/EditOHIP';
import { getHealthCardLabel } from 'services/portalData';
import DefaultModal from 'components/Utils/DefaultModal';
import './style.scss';
import healthCardImage from 'assets/img/health-card.webp';
import PatientUtils from 'services/PatientUtils';
import moment from 'moment-timezone';
const DATE_FORMAT = 'YYYY/MM/DD';

const OHIPFields = (props) => {
  let [isModalOpen, setModalOpen] = useState(false);

  return (
    <div className="ohip-fields">
      <OhipModal patient={props.patient} setModalOpen={setModalOpen} isModalOpen={isModalOpen} />
      <CardImage patient={props.patient} />
      <SaveButton setModalOpen={setModalOpen} allowEdit={props.allowEdit} />
    </div>
  );
};

OHIPFields.propTypes = {
  patient: PropTypes.object.isRequired,
  allowEdit: PropTypes.bool,
};

export default OHIPFields;

export const CardImage = ({ patient = { health_card: {} } }) => (
  <React.Fragment>
    {patient.health_card?.valid_card && (
      <div className="ohip-card">
        <img src={healthCardImage} alt={`${getHealthCardLabel()} Card`} />
        <div className="card-info">
          <div className="top-info">
            <span className="bold">{getName(patient.health_card)}</span>
            <span className="bold">
              {formatCard(patient.health_card.health_number, patient.health_card.version_code)}
            </span>
          </div>
          <div className="bottom-info">
            <div className="left">
              <span>Born</span>
              <span className="bold">
                {PatientUtils.getBirthdate(patient.health_card, DATE_FORMAT)}
              </span>
              <span>Expiry</span>
              <span className="bold">
                {moment.unix((patient.health_card.expiry_date || [])[0]).format(DATE_FORMAT)}
              </span>
            </div>
            <div className="right">
              <span>Sex</span>
              <span className="bold">{patient.health_card.gender}</span>
            </div>
          </div>
        </div>
      </div>
    )}
    {!patient.health_card?.valid_card && (
      <span className="small-title">No valid {getHealthCardLabel()} card configured!</span>
    )}
  </React.Fragment>
);

const SaveButton = (props) => (
  <div key="update-ohip-div">
    <DefaultButton
      id="ohip-button"
      name={`Update ${getHealthCardLabel()}`}
      onClick={() => props.setModalOpen(true)}
      hide={!props.allowEdit}
      style={{ width: '200px', marginTop: '5px' }}
    />
  </div>
);

export const OhipModal = (props) => {
  return (
    props.isModalOpen && (
      <DefaultModal
        key="ohip-modal"
        className="fit-modal ohip-modal"
        wrap={true}
        title={`Update ${getHealthCardLabel()}`}
        isOpen={props.isModalOpen}
        onRequestClose={() => props.setModalOpen(false)}
        content={
          <React.Fragment>
            <CardImage patient={props.patient} />
            <EditOHIP patient={props.patient} onSuccess={() => props.setModalOpen(false)} />
          </React.Fragment>
        }
      />
    )
  );
};

function formatCard(number, version) {
  return `${number}-${version} `;
}

function getName(healthCard) {
  let name = healthCard.first_name;
  if (healthCard.second_name) name += ` ${healthCard.second_name}`;
  name += ` ${healthCard.last_name}`;
  return name;
}
